import { render, staticRenderFns } from "./cookings.vue?vue&type=template&id=ae212b7c&"
import script from "./cookings.vue?vue&type=script&lang=js&"
export * from "./cookings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports